import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import fi from "date-fns/locale/fi";
import {
  dateTimePickerFormat_time,
  dateTimePickerFormat_date,
  dateTimeFormat_YYYYMMDD_HHmmss,
  dateFormat_HHmm,
  dateTimeFormat_YYYYMMDD_HHmm,
  dateFormat_DDMMYYYY,
} from "../../constants/dateFormats";
import moment, { MomentInput } from "moment";

const FormikDateTimePicker = ({ ...props }: any) => {
  const { setFieldValue } = useFormikContext<any>();
  const [field] = useField(props);

  const selectedDate = moment(field.value || "", dateTimeFormat_YYYYMMDD_HHmmss, true);
  if (selectedDate.isValid()) {
    field.value = selectedDate.format(dateFormat_DDMMYYYY + " " + dateFormat_HHmm);
  } else {
    field.value = "";
  }
  const isInvalid = !selectedDate.isValid();
  const isInvalidClassname = isInvalid ? "is-invalid" : "";

  return (
    <DatePicker
      {...field}
      {...props}
      selected={selectedDate.isValid() ? selectedDate.toDate() : null}
      onChange={(val: MomentInput) => {
        const momentVal = moment(val);

        if (momentVal.isValid()) {
          const formattedVal = momentVal.format(dateTimeFormat_YYYYMMDD_HHmm) + ":00";
          setFieldValue(field.name, formattedVal);
        } else {
          setFieldValue(field.name, "");
        }
      }}
      className={"form-control " + isInvalidClassname}
      showTimeSelect
      locale={fi}
      timeCaption={"klo"}
      dateFormat={dateTimePickerFormat_date}
      timeFormat={dateTimePickerFormat_time}
      wrapperClassName={isInvalidClassname}
      autoComplete={"off"}
      minDate={props.minDate}
      maxDate={props.maxDate}
    />
  );
};

export default FormikDateTimePicker;
